import createEngineRoot from './createEngineRoot'

// placeholder for declaring intent
const createEngineForUI = createEngineRoot

export default createEngineForUI
